import styled from "styled-components";
import Hero from "src/components/Hero/Hero";
import { Row, Col } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import ReactMarkdown from "react-markdown";
import ResponsiveImage from "src/components/ImageWrapper/ResponsiveImage";
import SubTitleSection from "src/components/SubTitleSection/SubTitleSection";
import MarkdownWithRouter from "src/components/MarkdownWithRouter";
import EventFinished from "src/components/EventFinished";

const FreeLobsterAndShrimpRoll2026 = () => {
  const { t, i18n } = useTranslation();

  return (
    <FreeLobsterAndShrimpRoll2026Div>
      <EventFinished eventType="promotion" scheduleKeyName="freeLobsterAndShrimpRoll2026" />
      <Hero
        bgImage="promotions/dining/free-lobster-and-shrimp-roll-2026/Free_lobster-and-shrimp-roll-Header-2560x800px.jpg"
        buttonSettings={null}
        image={`promotions/dining/free-lobster-and-shrimp-roll-2026/Free_lobster-and-shrimp-roll-Logo-2400px-${i18n.language}.png`}
        darkenBg={0}
        description={t("diningPromos.freeLobsterAndShrimpRoll2026.hero.title")}
        descriptionBgColor="#0000004d"
      >
      </Hero>
      <MainContentDiv>
        <container-div>
          <Row className="g-4 mb-5" xs={1} md={2}>
            <Col>
              <SubTitleSection
                as={"h2"}
                subTitle={t("diningPromos.freeLobsterAndShrimpRoll2026.content.subtitle")}
              />
              <ReactMarkdown className="desc">
                {t("diningPromos.freeLobsterAndShrimpRoll2026.content.lunch.description")}
              </ReactMarkdown>
              <MarkdownWithRouter>
                {t("diningPromos.freeLobsterAndShrimpRoll2026.content.pgPlayersCard")}
              </MarkdownWithRouter>
            </Col>
            <Col className="pt-md-4">
              <ResponsiveImage
                src={`promotions/dining/free-lobster-and-shrimp-roll-2026/Free_lobster-and-shrimp-roll-Secondary-LP-Image-2400x1600.jpg`}
                alt={t("diningPromos.freeLobsterAndShrimpRoll2026.hero.title")}
              />
            </Col>
          </Row>
        </container-div>
      </MainContentDiv>
      <container-div>
        <center-content>
          <p className="small">
            {t("diningPromos.freeLobsterAndShrimpRoll2026.content.smallText")}
          </p>
        </center-content>
      </container-div>
    </FreeLobsterAndShrimpRoll2026Div>
  );
};

const FreeLobsterAndShrimpRoll2026Div = styled.div`
  width: 100%;
  height: auto;
  background: var(--lightblack);
  color: var(--white);
  padding-bottom: 1rem;
  .hero_image {
    padding: 2rem 2rem 4rem;
    @media (min-width: 768px) {
      padding: 3rem;
    }
    opacity: 0.9;
  }
  .small {
    text-align: center;
    max-width: 1100px;
    word-wrap: break-word;
  };
  h5 {
    margin-top: 2rem;
    font-weight: bold;
  }
    `;

const MainContentDiv = styled.div`
  padding-bottom: 1rem;
  h2:after {
    border-color: #d37333;
  }
  @media (min-width: 768px) {
    padding: 2rem 1rem 1rem;
  }
  container-div {
    background: rgba(0, 0, 0, 0.5);
  }
  height: auto;
  width: 100%;
  text-align: left;
  .p_1 strong {
    white-space: nowrap;
  }
  .desc strong {
    color: #d37333;
  }
  p {
    margin-bottom: 1rem;
  }
`;

export default FreeLobsterAndShrimpRoll2026;